const SystemMessageStore = {
  namespaced: true,
  state: {
    text: '',
    color: '',
    display: false
  },
  getters: {
    snackbarDisplay: (state) => {
      return state.display && !!state.text
    },
    snackbarColor: (state) => {
      if (!state.color) {
        return 'grey'
      } else {
        return state.color
      }
    },
    snackbarText: (state) => {
      return state.text
    }
  },
  mutations: {
    create (state, data) {
      state.text = data.text
      state.color = data.color
      state.display = true
    },
    destroy (state) {
      state.text = ''
      state.color = ''
      state.display = false
    }
  },
  actions: {
    createMessage (context, { status, message }) {
      context.commit('create', responseConverter(status, message))
    },
    createNotStatusMessage (context, { color, text }) {
      context.commit('create', { color: color, text: text })
    },
    destroyMessage (context) {
      context.commit('destroy')
    }
  }
}

const responseConverter = (status, message) => {
  if (status == 200) {
    return {
      color: 'success',
      text: message
    }
  } else {
    return {
      color: 'error',
      text: `エラーが発生しました（${message}）`
    }
  }
}

export default SystemMessageStore
